import {
  env,
  subEnv,
} from './helper/env';


// eslint-disable-next-line no-console
console.log(`env: ${env}, subEnv: ${subEnv}`);


const config = {
  // 全局配置
  env,
  subEnv,
  reqTimeout: 20000,
  monitorProjectName: 'h5-blind-box',
  blackHost: '//m.black-unique.com',
  chuxingyouhuiHost: '//pyp-api.chuxingyouhui.com',
  phpHost: '//pyp-api.chuxingyouhui.com/api',
  knightCard: '//m.black-unique.com',
  // 登录墙白名单
  loginwallWhiteList: ['customer-service', 'test-page', 'knight-festival/supportWC', 'order-red-envelopes/share', 'order-red-envelopes/help', 'wechat-authorization'],
  jumpLoginPageList: ['integral-system-tab', 'integral-system'],
  // 微信授权后的code
  wechatCodeKey: 'promoWechatCode',
  wechatCodeCbUrl: 'promoWechatCallbackUrl',
  // 长大红包
  grow: {
    apiHost: '//market.chuxingyouhui.com/promo-bargain-api',
    appId: '1194494896220667904',
    bargainActivityId: '1190085648443379712',
    downloadLink: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.black.unique&ckey=CK1443111099191',
  },
  // 返现业务
  fanxian: '//fanxian-api.chuxingyouhui.com',

  // 福袋
  luckyBag: {
    apiHost: '',
    baseUrl: '/activity/luckBag/api',
  },

  task618: {
    appId: '1194494896221667906',
  },

  knightFestival: {
    appId: '1194494896221667907',
  },

  double11: {
    appId: '1194494896221667910',
  },

  // 客服
  customer: {
    apiHost: '//customer-api.chuxingyouhui.com',
  },

  // 金卡
  vipCard: {
    apiHost: '//vip-member.chuxingyouhui.com/vip-member',
    homeApiHost: '//pyp-api.chuxingyouhui.com/api',
    appId: '1194494896220667905',
    appIdHome: 'qsjk',
  },

  hourlyLottery: {
    appId: '1194494896220667904',
  },
  earnCoins: {
    appId: '1194494896220667904',
    apiHost: '//market.chuxingyouhui.com/promo-bargain-api',
  },
  // 营销活动共用
  marketApi: {
    appId: '1194494896220667904',
    apiHost: '//market.chuxingyouhui.com/promo-bargain-api',
  },
  // 种树活动
  orchard: {
    // apiHost: 'http://172.16.202.155:8080/promo-bargain-api/garden/api/v1_0',
    apiHost: '//market.chuxingyouhui.com/promo-bargain-api/garden/api/v1_0',
    // apiHost: '//box2-market.chuxingyouhui.com/promo-bargain-api/garden/api/v1_0',
    appId: '1194494896220667904',
  },

  // 史莱姆
  subscriptionLottery: {
    apiHost: '//sbts-api.chuxingyouhui.com/api',
  },

  orderRedEnvelop: {
    appId: '1194494896221667909',
    apiHost: '//market.chuxingyouhui.com/promo-bargain-api',
  },
  // 卡券裂变
  couponsFission: {
    apiHost: '//market.chuxingyouhui.com/promo-bargain-api',
  },
  // 网赚充能
  chargeingMoney: {
    apiHost: 'http://172.16.220.97:8080/',
  },
  miniProgramVersion: 0, //  (0-正式版 1-开发版 2-体验版)

  // 充电得宝
  charging: '//box-battery-charging-api.miyoujishi.com',
  // charging: '//172.16.110.81:8080',
  // 提审渠道
  taiShenList: ['xiaochengxuzg'],
  zfbMiniList: [{
    appId: '2021003104634071',
    name: '蜜柚潮购',
    commonClasName: 'zfbMiniSkin',
    className: '',
  }, {
    appId: '2021003103646252',
    name: '包有好货',
    commonClasName: 'zfbMiniSkin',
    className: '',
  }],
};

switch (env) {
  case 'box':
    config.blackHost = `//${subEnv}-m.black-unique.com`;
    config.chuxingyouhuiHost = `//${subEnv}-pyp-api.chuxingyouhui.com`;
    config.knightCard = `//${subEnv}-mg.black-unique.com`;
    config.grow.apiHost = `//${subEnv}-market.chuxingyouhui.com/promo-bargain-api`;
    config.couponsFission.apiHost = `//${subEnv}-market.chuxingyouhui.com/promo-bargain-api`;
    config.customer.apiHost = `//${subEnv}-customer-api.chuxingyouhui.com`;
    config.vipCard.apiHost = `//${subEnv}-vip-member.chuxingyouhui.com/vip-member`;
    config.phpHost = `//${subEnv}-pyp-api.chuxingyouhui.com/api`;
    config.earnCoins.apiHost = `//${subEnv}-market.chuxingyouhui.com/promo-bargain-api`;
    config.orchard.apiHost = `//${subEnv}-market.chuxingyouhui.com/promo-bargain-api/garden/api/v1_0`;
    config.marketApi.apiHost = `//${subEnv}-market.chuxingyouhui.com/promo-bargain-api`;
    config.subscriptionLottery.apiHost = `//${subEnv}-sbts-api.chuxingyouhui.com/api`;
    config.fanxian = `//${subEnv}-fanxian-api.chuxingyouhui.com`;
    config.miniProgramVersion = 2;
    config.charging = `//${subEnv}-battery-charging-api.miyoujishi.com`;
    break;
  case 'test':
    config.blackHost = `//${subEnv}-m.black-unique.com`;
    config.chuxingyouhuiHost = `//${subEnv}-pyp-api.chuxingyouhui.com`;
    config.knightCard = `//${subEnv}-mg.black-unique.com`;
    config.grow.apiHost = `//${subEnv}-market.chuxingyouhui.com/promo-bargain-api`;
    config.couponsFission.apiHost = `//${subEnv}-market.chuxingyouhui.com/promo-bargain-api`;
    config.customer.apiHost = `//${subEnv}-customer-api.chuxingyouhui.com`;
    config.vipCard.apiHost = `//${subEnv}-vip-member.chuxingyouhui.com/vip-member`;
    config.phpHost = `//${subEnv}-pyp-api.chuxingyouhui.com/api`;
    config.orchard.apiHost = `//${subEnv}-market.chuxingyouhui.com/promo-bargain-api/garden/api/v1_0`;
    config.earnCoins.apiHost = `//${subEnv}-market.chuxingyouhui.com/promo-bargain-api`;
    config.marketApi.apiHost = `//${subEnv}-market.chuxingyouhui.com/promo-bargain-api`;
    config.subscriptionLottery.apiHost = `//${subEnv}-sbts-api.chuxingyouhui.com/api`;
    config.fanxian = `//${subEnv}-fanxian-api.chuxingyouhui.com`;
    config.miniProgramVersion = 2;
    config.charging = `//${subEnv}-battery-charging-api.miyoujishi.com`;
    break;
  case 'prod':
    break;
  default:
    break;
}

export default config;
